export enum TestDataCategoryType {
  General,
  Temporal,
  Spatial,
  Clearance,
}
